module.exports = __webpack_public_path__ + "static/11_Google-46dc3bc7bbb0a9b895e89fae4a559ecc.png";